export default function isActionTriggerValid (el, triggerName) {
  return el.target.dataset.action === triggerName;
}
